import LineArtIcon from './component'

export default LineArtIcon
